import {createSinglePathSVG} from './TEMPLATE'

export const MagnifyingGlass_Filled_Stroke2_Corner0_Rounded =
  createSinglePathSVG({
    path: 'M5 11a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-8a8 8 0 1 0 4.906 14.32l3.387 3.387a1 1 0 0 0 1.414-1.414l-3.387-3.387A8 8 0 0 0 11 3Zm4 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z',
  })
